
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Früher wurde angenommen, dass diese Schmerzen von Muskelverspannungen am Schädel
herrühren. Das war knapp daneben. Heute weiss man: Es sind Verspannungen im
Schulter-Nacken-Bereich, die solche Kopfschmerzen häufig auslösen. Vier von fünf
Erwachsenen leiden mindestens einmal pro Jahr daran. Welche Abläufe im Körper
genau zu dieser Art von Kopfschmerzen führen, ist nicht bekannt. Obwohl
Spannungskopfschmerzen häufiger sind als Migräne, sind sie weniger gut
erforscht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;